import { useParams } from "react-router-dom";
import { gatewayActions } from "./gateway-actions";
import { GatewayActions } from "gql/graphql";
import { ToPageNotFound } from "@/shared/redirects/to-page-not-found";

export default function Gateway() {
  const { action } = useParams<{ action: GatewayActions }>();

  if (action === undefined || !(action in GatewayActions)) {
    return <ToPageNotFound />;
  }

  const Component = gatewayActions[action];

  return <Component />;
}
